import { Configuration } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';
import { getHeaderManifest } from '@carvana/header';

const mfeCacheBuster = () => {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;

  return `${date.getDate()}${date.getHours()}${nearestQuarterHour}`;
};

export const config: Configuration = {
  name: 'mycarsui',
  debug: false,
  Render: MfeReact(),
  ENV: process.env.NODE_ENV || 'production',
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    styled: () => import('styled-components'),
    'styled-components': () => import('styled-components'),
    PropTypes: () => import('prop-types'),
    'prop-types': () => import('prop-types'),
  },
  files: [
    [
      'FooterModule',
      [
        {
          component: 'default',
          browser: true,
          default: {
            file: 'index.js',
            manifest: `${
              process.env.CARVANA_APP_CDN_URL_FASTLY
            }/footer/module/assets-manifest.json?v=${mfeCacheBuster()}`,
          },
        },
      ],
    ],
    [
      'HeaderModule',
      [
        {
          component: 'default',
          default: {
            file: 'index.js',
            manifest: getHeaderManifest(process.env.CVNA_APP_ENVIRONMENT),
          },
        },
      ],
    ],
    [
      'AccountModal',
      [
        {
          chunks: ['index.css'],
          // priority: 'high',
          component: 'default',
          default: {
            file: 'index.js',
            manifest: `${process.env.CARVANA_APP_CDN_URL_FASTLY}/authentication-flows/account-modal/assets-manifest.json`,
          },
        },
      ],
    ],
    [
      'OneTimePasswordModal',
      [
        {
          chunks: ['index.css'],
          component: 'default',
          default: {
            file: 'index.js',
            manifest: `${
              process.env.CARVANA_APP_CDN_URL_FASTLY
            }/authentication-flows/one-time-password-modal/assets-manifest.json?v=${mfeCacheBuster()}`,
          },
        },
      ],
    ],
  ],
};

export default config;
